/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TrustIndexRouteImport } from './routes/trust/index'
import { Route as TrustSandboxRouteImport } from './routes/trust/sandbox'
import { Route as TrustPermissionsRouteImport } from './routes/trust/permissions'
import { Route as TrustDataResidencyRouteImport } from './routes/trust/data-residency'
import { Route as TrustAuditRouteImport } from './routes/trust/audit'
import { Route as TrustArchitectureRouteImport } from './routes/trust/architecture'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as OnboardNewRouteImport } from './routes/onboard/new'
import { Route as LearnLoraRouteImport } from './routes/learn/lora'
import { Route as CClientSlugRouteImport } from './routes/c/$clientSlug'
import { Route as AdminPortalsRouteImport } from './routes/admin/portals'
import { Route as CClientSlugIndexRouteImport } from './routes/c/$clientSlug/index'
import { Route as CClientSlugSkillsRouteImport } from './routes/c/$clientSlug/skills'
import { Route as CClientSlugSignedOutRouteImport } from './routes/c/$clientSlug/signed-out'
import { Route as CClientSlugSharepointRouteImport } from './routes/c/$clientSlug/sharepoint'
import { Route as CClientSlugDesktopRouteImport } from './routes/c/$clientSlug/desktop'
import { Route as AdminPortalsNewRouteImport } from './routes/admin/portals/new'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustIndexRoute = TrustIndexRouteImport.update({
  id: '/trust/',
  path: '/trust/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustSandboxRoute = TrustSandboxRouteImport.update({
  id: '/trust/sandbox',
  path: '/trust/sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustPermissionsRoute = TrustPermissionsRouteImport.update({
  id: '/trust/permissions',
  path: '/trust/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustDataResidencyRoute = TrustDataResidencyRouteImport.update({
  id: '/trust/data-residency',
  path: '/trust/data-residency',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustAuditRoute = TrustAuditRouteImport.update({
  id: '/trust/audit',
  path: '/trust/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustArchitectureRoute = TrustArchitectureRouteImport.update({
  id: '/trust/architecture',
  path: '/trust/architecture',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardNewRoute = OnboardNewRouteImport.update({
  id: '/onboard/new',
  path: '/onboard/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnLoraRoute = LearnLoraRouteImport.update({
  id: '/learn/lora',
  path: '/learn/lora',
  getParentRoute: () => rootRouteImport,
} as any)
const CClientSlugRoute = CClientSlugRouteImport.update({
  id: '/c/$clientSlug',
  path: '/c/$clientSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPortalsRoute = AdminPortalsRouteImport.update({
  id: '/admin/portals',
  path: '/admin/portals',
  getParentRoute: () => rootRouteImport,
} as any)
const CClientSlugIndexRoute = CClientSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CClientSlugRoute,
} as any)
const CClientSlugSkillsRoute = CClientSlugSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => CClientSlugRoute,
} as any)
const CClientSlugSignedOutRoute = CClientSlugSignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => CClientSlugRoute,
} as any)
const CClientSlugSharepointRoute = CClientSlugSharepointRouteImport.update({
  id: '/sharepoint',
  path: '/sharepoint',
  getParentRoute: () => CClientSlugRoute,
} as any)
const CClientSlugDesktopRoute = CClientSlugDesktopRouteImport.update({
  id: '/desktop',
  path: '/desktop',
  getParentRoute: () => CClientSlugRoute,
} as any)
const AdminPortalsNewRoute = AdminPortalsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminPortalsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/admin/portals': typeof AdminPortalsRouteWithChildren
  '/c/$clientSlug': typeof CClientSlugRouteWithChildren
  '/learn/lora': typeof LearnLoraRoute
  '/onboard/new': typeof OnboardNewRoute
  '/share/$token': typeof ShareTokenRoute
  '/trust/architecture': typeof TrustArchitectureRoute
  '/trust/audit': typeof TrustAuditRoute
  '/trust/data-residency': typeof TrustDataResidencyRoute
  '/trust/permissions': typeof TrustPermissionsRoute
  '/trust/sandbox': typeof TrustSandboxRoute
  '/trust/': typeof TrustIndexRoute
  '/admin/portals/new': typeof AdminPortalsNewRoute
  '/c/$clientSlug/desktop': typeof CClientSlugDesktopRoute
  '/c/$clientSlug/sharepoint': typeof CClientSlugSharepointRoute
  '/c/$clientSlug/signed-out': typeof CClientSlugSignedOutRoute
  '/c/$clientSlug/skills': typeof CClientSlugSkillsRoute
  '/c/$clientSlug/': typeof CClientSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/admin/portals': typeof AdminPortalsRouteWithChildren
  '/learn/lora': typeof LearnLoraRoute
  '/onboard/new': typeof OnboardNewRoute
  '/share/$token': typeof ShareTokenRoute
  '/trust/architecture': typeof TrustArchitectureRoute
  '/trust/audit': typeof TrustAuditRoute
  '/trust/data-residency': typeof TrustDataResidencyRoute
  '/trust/permissions': typeof TrustPermissionsRoute
  '/trust/sandbox': typeof TrustSandboxRoute
  '/trust': typeof TrustIndexRoute
  '/admin/portals/new': typeof AdminPortalsNewRoute
  '/c/$clientSlug/desktop': typeof CClientSlugDesktopRoute
  '/c/$clientSlug/sharepoint': typeof CClientSlugSharepointRoute
  '/c/$clientSlug/signed-out': typeof CClientSlugSignedOutRoute
  '/c/$clientSlug/skills': typeof CClientSlugSkillsRoute
  '/c/$clientSlug': typeof CClientSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/admin/portals': typeof AdminPortalsRouteWithChildren
  '/c/$clientSlug': typeof CClientSlugRouteWithChildren
  '/learn/lora': typeof LearnLoraRoute
  '/onboard/new': typeof OnboardNewRoute
  '/share/$token': typeof ShareTokenRoute
  '/trust/architecture': typeof TrustArchitectureRoute
  '/trust/audit': typeof TrustAuditRoute
  '/trust/data-residency': typeof TrustDataResidencyRoute
  '/trust/permissions': typeof TrustPermissionsRoute
  '/trust/sandbox': typeof TrustSandboxRoute
  '/trust/': typeof TrustIndexRoute
  '/admin/portals/new': typeof AdminPortalsNewRoute
  '/c/$clientSlug/desktop': typeof CClientSlugDesktopRoute
  '/c/$clientSlug/sharepoint': typeof CClientSlugSharepointRoute
  '/c/$clientSlug/signed-out': typeof CClientSlugSignedOutRoute
  '/c/$clientSlug/skills': typeof CClientSlugSkillsRoute
  '/c/$clientSlug/': typeof CClientSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/admin/portals'
    | '/c/$clientSlug'
    | '/learn/lora'
    | '/onboard/new'
    | '/share/$token'
    | '/trust/architecture'
    | '/trust/audit'
    | '/trust/data-residency'
    | '/trust/permissions'
    | '/trust/sandbox'
    | '/trust/'
    | '/admin/portals/new'
    | '/c/$clientSlug/desktop'
    | '/c/$clientSlug/sharepoint'
    | '/c/$clientSlug/signed-out'
    | '/c/$clientSlug/skills'
    | '/c/$clientSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/admin/portals'
    | '/learn/lora'
    | '/onboard/new'
    | '/share/$token'
    | '/trust/architecture'
    | '/trust/audit'
    | '/trust/data-residency'
    | '/trust/permissions'
    | '/trust/sandbox'
    | '/trust'
    | '/admin/portals/new'
    | '/c/$clientSlug/desktop'
    | '/c/$clientSlug/sharepoint'
    | '/c/$clientSlug/signed-out'
    | '/c/$clientSlug/skills'
    | '/c/$clientSlug'
  id:
    | '__root__'
    | '/'
    | '/sign-in'
    | '/admin/portals'
    | '/c/$clientSlug'
    | '/learn/lora'
    | '/onboard/new'
    | '/share/$token'
    | '/trust/architecture'
    | '/trust/audit'
    | '/trust/data-residency'
    | '/trust/permissions'
    | '/trust/sandbox'
    | '/trust/'
    | '/admin/portals/new'
    | '/c/$clientSlug/desktop'
    | '/c/$clientSlug/sharepoint'
    | '/c/$clientSlug/signed-out'
    | '/c/$clientSlug/skills'
    | '/c/$clientSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SignInRoute: typeof SignInRoute
  AdminPortalsRoute: typeof AdminPortalsRouteWithChildren
  CClientSlugRoute: typeof CClientSlugRouteWithChildren
  LearnLoraRoute: typeof LearnLoraRoute
  OnboardNewRoute: typeof OnboardNewRoute
  ShareTokenRoute: typeof ShareTokenRoute
  TrustArchitectureRoute: typeof TrustArchitectureRoute
  TrustAuditRoute: typeof TrustAuditRoute
  TrustDataResidencyRoute: typeof TrustDataResidencyRoute
  TrustPermissionsRoute: typeof TrustPermissionsRoute
  TrustSandboxRoute: typeof TrustSandboxRoute
  TrustIndexRoute: typeof TrustIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/': {
      id: '/trust/'
      path: '/trust'
      fullPath: '/trust/'
      preLoaderRoute: typeof TrustIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/sandbox': {
      id: '/trust/sandbox'
      path: '/trust/sandbox'
      fullPath: '/trust/sandbox'
      preLoaderRoute: typeof TrustSandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/permissions': {
      id: '/trust/permissions'
      path: '/trust/permissions'
      fullPath: '/trust/permissions'
      preLoaderRoute: typeof TrustPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/data-residency': {
      id: '/trust/data-residency'
      path: '/trust/data-residency'
      fullPath: '/trust/data-residency'
      preLoaderRoute: typeof TrustDataResidencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/audit': {
      id: '/trust/audit'
      path: '/trust/audit'
      fullPath: '/trust/audit'
      preLoaderRoute: typeof TrustAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/architecture': {
      id: '/trust/architecture'
      path: '/trust/architecture'
      fullPath: '/trust/architecture'
      preLoaderRoute: typeof TrustArchitectureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboard/new': {
      id: '/onboard/new'
      path: '/onboard/new'
      fullPath: '/onboard/new'
      preLoaderRoute: typeof OnboardNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/lora': {
      id: '/learn/lora'
      path: '/learn/lora'
      fullPath: '/learn/lora'
      preLoaderRoute: typeof LearnLoraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$clientSlug': {
      id: '/c/$clientSlug'
      path: '/c/$clientSlug'
      fullPath: '/c/$clientSlug'
      preLoaderRoute: typeof CClientSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/portals': {
      id: '/admin/portals'
      path: '/admin/portals'
      fullPath: '/admin/portals'
      preLoaderRoute: typeof AdminPortalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$clientSlug/': {
      id: '/c/$clientSlug/'
      path: '/'
      fullPath: '/c/$clientSlug/'
      preLoaderRoute: typeof CClientSlugIndexRouteImport
      parentRoute: typeof CClientSlugRoute
    }
    '/c/$clientSlug/skills': {
      id: '/c/$clientSlug/skills'
      path: '/skills'
      fullPath: '/c/$clientSlug/skills'
      preLoaderRoute: typeof CClientSlugSkillsRouteImport
      parentRoute: typeof CClientSlugRoute
    }
    '/c/$clientSlug/signed-out': {
      id: '/c/$clientSlug/signed-out'
      path: '/signed-out'
      fullPath: '/c/$clientSlug/signed-out'
      preLoaderRoute: typeof CClientSlugSignedOutRouteImport
      parentRoute: typeof CClientSlugRoute
    }
    '/c/$clientSlug/sharepoint': {
      id: '/c/$clientSlug/sharepoint'
      path: '/sharepoint'
      fullPath: '/c/$clientSlug/sharepoint'
      preLoaderRoute: typeof CClientSlugSharepointRouteImport
      parentRoute: typeof CClientSlugRoute
    }
    '/c/$clientSlug/desktop': {
      id: '/c/$clientSlug/desktop'
      path: '/desktop'
      fullPath: '/c/$clientSlug/desktop'
      preLoaderRoute: typeof CClientSlugDesktopRouteImport
      parentRoute: typeof CClientSlugRoute
    }
    '/admin/portals/new': {
      id: '/admin/portals/new'
      path: '/new'
      fullPath: '/admin/portals/new'
      preLoaderRoute: typeof AdminPortalsNewRouteImport
      parentRoute: typeof AdminPortalsRoute
    }
  }
}

interface AdminPortalsRouteChildren {
  AdminPortalsNewRoute: typeof AdminPortalsNewRoute
}

const AdminPortalsRouteChildren: AdminPortalsRouteChildren = {
  AdminPortalsNewRoute: AdminPortalsNewRoute,
}

const AdminPortalsRouteWithChildren = AdminPortalsRoute._addFileChildren(
  AdminPortalsRouteChildren,
)

interface CClientSlugRouteChildren {
  CClientSlugDesktopRoute: typeof CClientSlugDesktopRoute
  CClientSlugSharepointRoute: typeof CClientSlugSharepointRoute
  CClientSlugSignedOutRoute: typeof CClientSlugSignedOutRoute
  CClientSlugSkillsRoute: typeof CClientSlugSkillsRoute
  CClientSlugIndexRoute: typeof CClientSlugIndexRoute
}

const CClientSlugRouteChildren: CClientSlugRouteChildren = {
  CClientSlugDesktopRoute: CClientSlugDesktopRoute,
  CClientSlugSharepointRoute: CClientSlugSharepointRoute,
  CClientSlugSignedOutRoute: CClientSlugSignedOutRoute,
  CClientSlugSkillsRoute: CClientSlugSkillsRoute,
  CClientSlugIndexRoute: CClientSlugIndexRoute,
}

const CClientSlugRouteWithChildren = CClientSlugRoute._addFileChildren(
  CClientSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SignInRoute: SignInRoute,
  AdminPortalsRoute: AdminPortalsRouteWithChildren,
  CClientSlugRoute: CClientSlugRouteWithChildren,
  LearnLoraRoute: LearnLoraRoute,
  OnboardNewRoute: OnboardNewRoute,
  ShareTokenRoute: ShareTokenRoute,
  TrustArchitectureRoute: TrustArchitectureRoute,
  TrustAuditRoute: TrustAuditRoute,
  TrustDataResidencyRoute: TrustDataResidencyRoute,
  TrustPermissionsRoute: TrustPermissionsRoute,
  TrustSandboxRoute: TrustSandboxRoute,
  TrustIndexRoute: TrustIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
